import uuid from 'uuid/v4';
function generate() {
    return uuid();
}
export default generate;
//# sourceMappingURL=generate-id.js.map